import { TextBox } from "@progress/kendo-react-inputs"
import CustomButton from "../../../../../../components/stateless/customButton/CustomButton";
import { useDocketDetailsController } from "./DocketDetailsController";
import CustomDialog from "../../../../../../components/stateless/dialog/CustomDialog";
import HtmlRender from "../../../../../../components/stateless/htmlRender/HtmlRender";
import './DocketDetails.scss';

interface IDocketDetailsProps {
  docketDetails: any;
  filingId: any;
}

const DocketDetails = (
  props: IDocketDetailsProps
) => {
  const { docketDetails, filingId } = props;

  const {
    //redux
    filingHearingDocs,
    filingFiscalDocs,
    filingExplanatoryDocs,
    //values
    draftPreviewOpen,
    draftHtml,
    draftDropdownItems,
    //functions
    toggleDraftPreview,
    downloadPdf,
    parseUTCDate,
    emailLiaison
  } = useDocketDetailsController(docketDetails.drafts, filingId);

  return (
    <div
      style={{margin:'30px'}}
    >
      <CustomDialog
        open={draftPreviewOpen}
        size="large"
        toggleDialog={toggleDraftPreview}
        hideButtons
        title="Filing Draft"
      >
        <HtmlRender value={draftHtml ?? ''} />
      </CustomDialog>

        <div className='proposed-regulation-btn'>
          <CustomButton
            onClick={() => {}}
            disabled={draftDropdownItems.length < 1}
            dropdownChildren={draftDropdownItems}
            dropdownChildTextField="displayName"
            isDropdown
            onDropdownChildClick={(e) => {toggleDraftPreview(e.item.id)}}
            title="View Draft"
          >
            View Draft
          </CustomButton>
        </div>
        {docketDetails.hearingDetails.length > 0 && (
          <div>
            <h4>Hearing Information</h4>
          </div>
        )}
        {filingHearingDocs?.length > 0 && (
          <CustomButton
            onClick={() => {}}
            isDropdown
            dropdownChildren={filingHearingDocs}
            dropdownChildTextField="originalName"
            onDropdownChildClick={(e) => {downloadPdf(e.item.containerName, e.item.blobName)}}
            title="Hearing Docs"
          ></CustomButton>
        )}
        { docketDetails.hearingDetails.map((hearing: any, index: number) => (
          <div key={`hearing-info-${index}`} className='hearing-info-wrapper'>
            <div className='hearing-info'>
              <h5>Hearing {index + 1}</h5>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing Date</div>
                <div>
                  {!!hearing.hearingDateTime ? parseUTCDate(hearing.hearingDateTime) : null}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing Address 1</div>
                <div>
                  {hearing.hearingAddress1}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing Address 2</div>
                <div>
                  {hearing.hearingAddress2}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing City</div>
                <div>
                  {hearing.hearingCity}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing State</div>
                <div>
                  {hearing.hearingState}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing ZIP</div>
                <div>
                  {hearing.hearingZip}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing Contact Name</div>
                <div>
                  {hearing.hearingContactName}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Hearing Contact Phone</div>
                <div>
                  {hearing.hearingContactPhone}
                </div>
              </div>
              <div className='hearing-info-item'>
                <div className='hearing-info-desc'>Electronic Meeting Info</div>
                <div>
                  {hearing.hearingEMeetingInfo}
                </div>
              </div>
              {hearing.commentsAreLocked && (
                <div>Comments for the above hearing are locked.</div>
              )}
            </div>
            <div className='hearing-right'>
              <div className='hearing-info-item-right'>
                <div className='hearing-info-desc'>Send Comments To</div>
                <div>

                  <CustomButton
                    onClick={() => emailLiaison(hearing.hearingContactEmail)}
                    fillMode='link'
                    className='email-link'
                    title={hearing.hearingContactEmail}
                  >
                    {hearing.hearingContactEmail}
                  </CustomButton>

                </div>
              </div>
            </div>
          </div>

        ))}

      <div className='agency-info'>
        <div>
          <h4>Agency Information</h4>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>Agency Name:</div>
           <div>
            {docketDetails.agencyName}
          </div>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>Division:</div>
          <div>
            {docketDetails.agencyDivision}
          </div>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>Address:</div>
          <div>
              {docketDetails.agencyAddress}
          </div>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>City:</div>
          <div>
              {docketDetails.agencyCity}
          </div>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>State:</div>
          <div>
              {docketDetails.agencyState}
          </div>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>Zip Code:</div>
          <div>
              {docketDetails.agencyZip}
          </div>
        </div>
        <div className='agency-info-item'>
          <div className='agency-info-item-desc'>Phone:</div>
          <div>
              {docketDetails.agencyPhone}
          </div>
        </div>
        {docketDetails.isStandardWorkflow && (
          <div className='agency-info-item'>
            <div className='agency-info-item-desc'>Email:</div>
            <div>
                {docketDetails.agencyEmail}
            </div>
          </div>
        )}
      </div>

      <div className='accessibility-info'>
        <div>
          <h4>Accessibility Information</h4>
        </div>
        <div className='accessibility-info-item'>
          <div className='accessibility-info-item-desc'>Agency Contact:</div>
          <div>
              {docketDetails.accessibilityAgencyContact}
          </div>
        </div>
        <div className='accessibility-info-item'>
          <div className='accessibility-info-item-desc'>Agency Phone Number:</div>
          <div>
              {docketDetails.accessibilityAgencyPhone}
          </div>
        </div>
      </div>

      <div className="explanatory-info">
        <div>
          <h4>Explanatory Statement</h4>
        </div>
        {filingExplanatoryDocs.length > 0 ? (
          <CustomButton
            onClick={() => {}}
            isDropdown
            dropdownChildren={filingExplanatoryDocs}
            dropdownChildTextField="originalName"
            onDropdownChildClick={(e) => {downloadPdf(e.item.containerName, e.item.blobName)}}
            title="Explanatory Docs"
          ></CustomButton>
        ) : (
          <div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>Date Prepared:</div>
              <div>
                {!!docketDetails.explanatoryDate ? parseUTCDate(docketDetails.explanatoryDate) : null}
              </div>
            </div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>Reason for Adoption, Amendment, or Repeal:</div>
              <div>
                {docketDetails.reasonForAdoptionAmendmentRepeal}
              </div>
            </div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>Description of Purpose and Summary of Changes Made:</div>
              <div>
                  {docketDetails.descriptionAndSummaryOfRuleChanges}
              </div>
            </div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>Changes in Text between Notice and Hearing:</div>
              <div>
                {docketDetails.changesBetweenNoticeAndHearing}
              </div>
            </div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>FTE Impact:</div>
              <div>
                {docketDetails.fteImpact}
              </div>
            </div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>Unfunded Mandate:</div>
              <div>
                {docketDetails.unfundedMandate}
              </div>
            </div>
            <div className='explanatory-info-item'>
              <div className='explanatory-info-item-desc'>Issues of Unique Interest:</div>
              <div>
                {docketDetails.issuesOfUniqueInterest}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="fiscal-info">
        <div>
          <h4>Fiscal Impact Statement</h4>
        </div>
        {filingFiscalDocs.length > 0 ? (
          <CustomButton
            onClick={() => {}}
            isDropdown
            dropdownChildren={filingFiscalDocs}
            dropdownChildTextField="originalName"
            onDropdownChildClick={(e) => {downloadPdf(e.item.containerName, e.item.blobName)}}
            title="Fiscal Docs"
          ></CustomButton>
        ) : (
          <div>
            {/* STATE AGENCY */}
            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>State Agency</div>
              {
                docketDetails.stateAgencyHasNoFiscalImpact ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>No Fiscal Impact</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.stateAgencyHasIncreasedCost ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Increased Costs</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.stateAgencyHasDecreasedCost ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Decreased Costs</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.stateAgencyHasIncreasedRevenue ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Increased Revenue</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.stateAgencyHasDecreasedRevenue ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Decreased Revenue</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.stateAgencyIsIndeterminable ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Indeterminable</div>
                  </div>
                ) : ''
              }
            </div>

            {/* POLITICAL SUBDIVISION */}
            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>Political Subdivision</div>
              {
                docketDetails.politicalSubdivisionHasNoFiscalImpact ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>No Fiscal Impact</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.politicalSubdivisionHasIncreasedCost ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Increased Costs</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.politicalSubdivisionHasDecreasedCost ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Decreased Costs</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.politicalSubdivisionHasIncreasedRevenue ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Increased Revenue</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.politicalSubdivisionHasDecreasedRevenue ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Decreased Revenue</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.politicalSubdivisionIsIndeterminable ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Indeterminable</div>
                  </div>
                ) : ''
              }
            </div>

            {/* REGULATED PUBLIC */}
            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>Regulated Public</div>
              {
                docketDetails.regulatedPublicHasNoFiscalImpact ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>No Fiscal Impact</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.regulatedPublicHasIncreasedCost ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Increased Costs</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.regulatedPublicHasDecreasedCost ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Decreased Costs</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.regulatedPublicHasIncreasedRevenue ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Increased Revenue</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.regulatedPublicHasDecreasedRevenue ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Decreased Revenue</div>
                  </div>
                ) : ''
              }
              {
                docketDetails.regulatedPublicIsIndeterminable ? (
                  <div className='fiscal-item'>
                    <div className='fiscal-item-name'>Indeterminable</div>
                  </div>
                ) : ''
              }
            </div>

            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>Indeterminable Explanation</div>
              <div className='fiscal-item'>{docketDetails.indeterminableImpactDesc}</div>
            </div>

            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>State Agency Description of Impact</div>
              <div className='fiscal-item'>{docketDetails.stateAgencyImpactDesc}</div>
            </div>

            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>Political Subdivision Description of Impact</div>
              <div className='fiscal-item'>{docketDetails.politicalSubdivisionImpactDesc}</div>
            </div>

            <div className='fiscal-item-container'>
              <div className='fiscal-item-heading'>Regulated Public Description of Impact</div>
              <div className='fiscal-item'>{docketDetails.regulatedPublicImpactDesc}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DocketDetails;